import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_BY_ID } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { Comment } from '@utils/types/comments/comments.ts';

type CommentsResponse = {
  count: number;
  total_results: number;
  result: Comment[];
};

type GetCommentsVariables = {
  session_id: string;
  document_id: string;
};

export const useGetComments = ({
  session_id,
  document_id
}: GetCommentsVariables) => {
  const fetchComments = async () => {
    // Backend defaults to `resolved=open`, which strips resolved
    // comments out of the list. The gutter needs both slices (open +
    // resolved) so its filter chips + counters can render correctly —
    // so we always request `all` and filter client-side.
    const url = `${GET_URL_BY_ID(session_id, document_id).comments}?resolved=all`;
    const response = await Axios.get<CommentsResponse>(url);
    return response.data;
  };

  return useQuery<CommentsResponse, AxiosError<BaseError>>(
    ['comments', session_id, document_id],
    fetchComments
  );
};
